"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var SeeSource = function () { return (react_1["default"].createElement("div", { className: "SeeSource" },
    "Source[",
    react_1["default"].createElement("a", { href: 'https://github.com/GuillaumeElias/timeline-cv' }, "Github"),
    "]")); };
exports["default"] = SeeSource;
